import * as React from 'react';
import { useTheme } from '@mui/material';

import { EZoneCreateStatus } from 'enums';
import { StatusDots } from './status-dots';

interface ZoneCreateStatusDotsProps {
  status?: string;
}

export const ZoneCreateStatusDots: React.FC<ZoneCreateStatusDotsProps> = (props) => {
  const { status = EZoneCreateStatus.ADD_ZONE } = props;
  const theme = useTheme();

  const dots = [1, 2];

  const getBgColor = (dotIndex: number) => {
    if (dotIndex === dots[0] && status === EZoneCreateStatus.ADD_ZONE) {
      return theme.palette.primary.main;
    }

    if (dotIndex === dots[1] && status === EZoneCreateStatus.APPROVE_DECAL) {
      return theme.palette.primary.main;
    }

    return '#C4C4C4';
  };

  return <StatusDots dots={dots} getBgColor={getBgColor} />;
};
